import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import GenericDialog from "./generic";
import PlayTokenForm, {
  PlayTokenFormType,
} from "widgets/forms/devices/playToken";
import axios from "axios";

const PlayTokenDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  selected: any;
}) => {
  const { isOpen, onClose, onSuccess, selected } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Function for linking a user
  const doPlayToken = async (formData: PlayTokenFormType) => {
    dispatch(setLoading(true));

    try {
      const response = await axios.post(
        "https://api.in4mgroup.com:3001/api/usr/v2/device/playtoken",
        {
          meternumber: selected.snr,
          token: formData.token?.replace(/-/g, ""),
        },
        {
          headers: {
            "api-key":
              "50461f781478c1d30dbe77a47795f0ade57e832c57062a174bbc97c7366d9337",
            "Content-Type": "application/json",
          },
        }
      );

      dispatch(setLoading(false));

      if (response.status === 200) {
        onSuccess();
        notifySimple(t("notification.play.token.success"), "success");
        onClose();
      } else {
        notifySimple(t("notification.play.token.error"), "error");
      }
    } catch (error: any) {
      dispatch(setLoading(false));
      console.error("Play token error:", error);
      notifySimple(t("notification.play.token.error"), "error");
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.play.token.title")}
      onExit={onClose}
      size="lg"
    >
      <div className="-mt-6 flex flex-col gap-4">
        <div className="text-txt-md font-medium text-secondary">
          {t("dialog.play.token.description")}
        </div>
        <PlayTokenForm
          submit={doPlayToken}
          onClose={onClose}
          values={{
            meterNumber: selected.snr,
            token: undefined,
          }}
        />
      </div>
    </GenericDialog>
  );
};

export default PlayTokenDialog;
